<template>
  <div class="as-final-score">
    <div class="as-final-score__head">
      <IconFinalScore />
      <span> Điểm chung cuộc </span>
    </div>
    <div class="as-final-score__body">
        <div class="as-div"></div>
      <div class="as-result">
        <div class="as-scoreboard">
          <span class="as-match-item__vs as-t_vs_num">
            <span class="as-home-score" :class="{
              'as-winner' : footyStats && footyStats?.homeGoalCount > footyStats?.awayGoalCount
            }">{{ footyStats?.homeGoalCount }}</span>
            :
            <span class="as-away-score" :class="{
              'as-winner' : footyStats && footyStats?.homeGoalCount < footyStats?.awayGoalCount
            }">{{ footyStats?.awayGoalCount }}</span>
          </span>
        </div>
        <div class="as-result__scores">
            HT
            <span>
                {{ `${footyStats?.ht_goals_team_a ?? 0} - ${footyStats?.ht_goals_team_b ?? 0}` }}
            </span>
        </div>
      </div>
    </div>
    <IncidentsList :goalDetails="goalDetails" :players="footyStats?.list_players ?? []"/>
    <div class="as-competition" v-if="showTable()">
        <table class="as-competition__table">
            <thead>
                <tr>
                    <th>Thi đấu</th>
                    <th class="as-center a">
                      {{ footyStats?.home_name }}
                    </th>
                    <th class="as-center a">
                      {{ footyStats?.away_name }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Kiểm soát bóng</td>
                    <td :class=" `as-center ${getClassForItem(getValue('team_a_possession'))}`">
                      {{ getValue('team_a_possession') }}%
                    </td>
                    <td :class=" `as-center ${getClassForItem(getValue('team_b_possession'))}`">
                      {{ getValue('team_b_possession') }}%
                    </td>
                </tr>
                <tr>
                    <td>Cú sút</td>
                    <td :class=" `as-center ${getClassForItem(getValue('team_a_shots'))}`">
                      {{ getValue('team_a_shots') }}
                    </td>
                    <td :class=" `as-center ${getClassForItem(getValue('team_b_shots'))}`">
                      {{ getValue('team_b_shots') }}
                    </td>
                </tr>
                <tr>
                    <td>Thẻ</td>
                    <td :class=" `as-center ${getClassForItem(getValue('team_a_xg'))}`">
                      {{ getValue('a_card') }}
                    </td>
                    <td :class=" `as-center ${getClassForItem(getValue('team_a_xg'))}`">
                      {{ getValue('b_card') }}
                    </td>
                </tr>
                <tr>
                    <td>Phạt góc</td>
                    <td :class=" `as-center ${getClassForItem(getValue('team_a_corners'))}`">
                      {{ getValue('team_a_corners') }}
                    </td>
                    <td :class=" `as-center ${getClassForItem(getValue('team_b_corners'))}`">
                      {{ getValue('team_b_corners') }}
                    </td>
                </tr>
                <tr>
                    <td>Phạm lỗi</td>
                    <td :class=" `as-center ${getClassForItem(getValue('team_a_fouls'))}`">
                      {{ getValue('team_a_fouls') }}
                    </td>
                    <td :class=" `as-center ${getClassForItem(getValue('team_b_fouls'))}`">
                      {{ getValue('team_b_fouls') }}
                    </td>
                </tr>
                <tr>
                    <td>Việt vị</td>
                    <td :class=" `as-center ${getClassForItem(getValue('team_a_offsides'))}`">
                      {{ getValue('team_a_offsides') }}
                    </td>
                    <td :class=" `as-center ${getClassForItem(getValue('team_b_offsides'))}`">
                      {{ getValue('team_b_offsides') }}
                    </td>
                </tr>
                <tr>
                    <td>xG</td>
                    <td :class=" `as-center ${getClassForItem(getValue('team_a_xg'))}`">
                      {{ getValue('team_a_xg') }}
                    </td>
                    <td :class=" `as-center ${getClassForItem(getValue('team_b_xg'))}`">
                      {{ getValue('team_b_xg') }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="as-statics-list">
        <StaticsItem title="Trên 2.5" :mainValue="footyStats?.o25_potential || 0" :subValue="footyStats?.season_data?.seasonOver25Percentage_overall ?? 0"/>
        <StaticsItem title="Trên 1.5" :mainValue="footyStats?.o15_potential || 0" :subValue="footyStats?.season_data?.seasonOver15Percentage_overall ?? 0" classModify="as-green"/>
        <StaticsItem title="BTTS" :mainValue="footyStats?.btts_potential || 0" :subValue="footyStats?.season_data?.seasonBTTSPercentage ?? 0"/>
        <StaticsItem title="Bàn thắng/trận" :mainValue="footyStats?.avg_potential || 0" :subValue="footyStats?.season_data?.seasonAVG_overall ?? 0" classModify="as-blue"/>
        <StaticsItem title="Thẻ" :mainValue="footyStats?.cards_potential || 0" :subValue="footyStats?.season_data?.cardsAVG_overall ?? 0" classModify="as-blue"/>
        <StaticsItem title="Phạt góc" :mainValue="footyStats?.corners_potential || 0" :subValue="footyStats?.season_data?.cornersAVG_overall ?? 0" classModify="as-blue"/>
    </div>
  </div>
</template>
<script setup lang="ts">
import type { IMatch } from "~src/interfaces";
import IconFinalScore from "~src/components/icons/foot_stats/IconFinalScore.vue";
import IncidentsList from "~src/components/foot_stats/final_score/IncidentsList.vue";
import StaticsItem from "~src/components/foot_stats/final_score/StaticsItem.vue";
import type { IFootyStats, IGoalDetails } from "~src/interfaces/footystats";
import { computed } from "vue";
import { getClassForItem } from "~src/helpers/footystats";
interface Props {
  match: IMatch;
  footyStats: IFootyStats | null
}

const props = withDefaults(defineProps<Props>(), {
});

const goalDetails = computed<IGoalDetails[]>(() => {
  if (props.footyStats) {
    const { team_a_goal_details, team_b_goal_details } = props.footyStats;
    // Gộp thông tin bàn thắng
    const mergedGoals: IGoalDetails[] = [
      ...team_a_goal_details.map((goal: IGoalDetails) => ({
        ...goal,
        time: Number(goal.time),
        team: 'home'
      })),
      ...team_b_goal_details.map((goal: IGoalDetails) => ({
        ...goal,
        time: Number(goal.time),
        team: 'away'
      })),
    ]
      .sort((a: IGoalDetails, b: IGoalDetails) => a.time - b.time);

    let __home = 0;
    let __away = 0;

    // Tính điểm cho mỗi bàn thắng và gán điểm vào item
    const updatedGoals = mergedGoals.map((item: IGoalDetails) => {
      // Tăng số bàn thắng cho từng đội
      if (item.team === 'home') {
        __home += 1;
      }
      if (item.team === 'away') {
        __away += 1;
      }

      // Gán điểm vào item
      return {
        ...item,
        point: {
          home: __home,
          away: __away,
        },
      };
    });

    return updatedGoals;
  }

  return [];
});

const getValue = (key = '', is_none = false) => {
  const data = props.footyStats;
  if(data){
    let _val = data[key] ?? 0;

    if(key == 'a_card'){
      _val = data.team_a_yellow_cards + data.team_a_red_cards
    }

    if(key == 'b_card'){
      _val = data.team_b_yellow_cards + data.team_b_red_cards
    }

    if(_val < 0){
      return 'N/A'
    }

    return _val;
  }

  return 'N/A';
}

const showTable = () => {
  // console.log(getValue('team_a_possession'))
  // console.log(getValue('team_b_possession'))
  // console.log(getValue('team_a_shots'))
  // console.log(getValue('team_b_shots'))
  // console.log(getValue('a_card'))
  // console.log(getValue('b_card'))
  // console.log(getValue('team_a_corners'))
  // console.log(getValue('team_b_corners'))
  // console.log(getValue('team_a_fouls'))
  // console.log(getValue('team_b_fouls'))
  // console.log(getValue('team_a_offsides'))
  // console.log(getValue('team_b_offsides'))
  // console.log(getValue('team_a_xg'))
  // console.log(getValue('team_b_xg'))
  if(
    getValue('team_a_possession') === 'N/A'
    && getValue('team_b_possession') === 'N/A'
    && getValue('team_a_shots') === 'N/A'
    && getValue('team_b_shots') === 'N/A'
    && getValue('a_card') === 'N/A'
    && getValue('b_card') === 'N/A'
    && getValue('team_a_corners') === 'N/A'
    && getValue('team_b_corners') === 'N/A'
    && getValue('team_a_fouls') === 'N/A'
    && getValue('team_b_fouls') === 'N/A'
    && getValue('team_a_offsides') === 'N/A'
    && getValue('team_b_offsides') === 'N/A'
    && getValue('team_a_xg') === 'N/A'
    && getValue('team_b_xg') === 'N/A'
  ){
    return false;
  }
  return true
}

</script>
<script lang="ts">
export default {};
</script>
